import type { ReactNode } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  saveLabel: string;
  canSave: boolean;
  onSave: () => void;
  children: ReactNode;
};

/** A pop-up form: a title, fields in two columns (one on a phone), Cancel and a save button */
export function FormDialog({ open, onClose, title, saveLabel, canSave, onSave, children }: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'grid',
            gap: 1.5,
            pt: 1,
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))' },
          }}
        >
          {children}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={!canSave} onClick={onSave}>
          {saveLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

/** A field that spans both columns */
export const FullRow = ({ children }: { children: ReactNode }) => <Box sx={{ gridColumn: '1 / -1' }}>{children}</Box>;
